// plant pie chart gauge
import React, { useEffect, useRef } from "react";

export default function PlantMood({ setArrowPosition }) {
  const arrowRef = useRef(null);

  useEffect(() => {
    const updateArrowPosition = () => {
      if (!arrowRef.current) return;

      const computedStyle = getComputedStyle(arrowRef.current);
      const transform = computedStyle.transform;

      if (!transform || transform === "none") {
        setArrowPosition?.(0);
        return;
      }

      const matrix = new DOMMatrixReadOnly(transform);
      const angle = Math.round(
        Math.atan2(matrix.m21, matrix.m11) * (180 / Math.PI)
      );

      setArrowPosition?.((angle + 360) % 360);
    };

    const interval = setInterval(updateArrowPosition, 100);
    return () => clearInterval(interval);
  }, [setArrowPosition]);

  return (
    <div className="plant-pie-chart">
      <div ref={arrowRef} className="plant-arrow" />
      <img
        src="/stageAssets/stage1-plant/pieChart-plant.png"
        alt="Plant vitality chart"
      />
    </div>
  );
}